import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class WorkerService {
    private workers: Map<string, { worker: Worker; isTerminated: boolean }> = new Map();

    addWorker(key: string, worker: Worker): void {
        if (this.workers.has(key)) {
            this.terminateWorker(key);
        }
        this.workers.set(key, { worker, isTerminated: false });
    }

    getWorker(key: string): Worker | undefined {
        const entry = this.workers.get(key);
        return entry?.isTerminated ? undefined : entry?.worker;
    }

    isWorkerTerminated(key: string): boolean {
        const entry = this.workers.get(key);
        return entry ? entry.isTerminated : true;
    }

    terminateWorker(key: string): void {
        const entry = this.workers.get(key);
        if (entry && !entry.isTerminated) {
            entry.worker.terminate();
            entry.isTerminated = true;
        }
    }

    terminateAllWorkers(): void {
        this.workers.forEach((entry, key) => {
            if (!entry.isTerminated) {
                entry.worker.terminate();
                entry.isTerminated = true;
            }
        });
    }
}
